var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionHeadlineImage',{staticClass:"SectionWhyWorth",attrs:{"head":_vm.$t('head'),"headline":_vm.$t('headline'),"imageSrc":"../../../../assets/landing-static/map.png","side":_vm.$t('side')}})
}
var staticRenderFns = []

export { render, staticRenderFns }